/**
 * @file State and methods to query the STATE of application
 * @since v3.6
 */

import G3WObject from 'g3w-object';

/**
 * State of application reactive
 * @type {object}
 */
const STATE = Vue.observable({

  /**
   * true = application is ready
   */
  ready: false,

  /**
   * true = application is loaded inside an iframe
   */
  iframe: window.top !== window.self,

  /**
   * true = application is connected
   */
  online: navigator.onLine,

  /**
   * true = application is loaded on a mobile device
   */
  ismobile: isMobile.any,
  
  /**
   * true = there is a pending download 
   */
  download: false,

  /**
   * true = there is a pending upload
   */
  upload: false,

  /**
   * Store current map base layer id
   */
  baseLayerId: null,

  /**
   * en = default language
   */
  language: 'en',

  /**
   * Store all i18n objects
   * 
   * @since 4.0.0
   */
  locales: {},

  /**
   * Store Array of loading plugins (by name)
   * Every time a plugin is loaded, plugin name is removed from Array
   * It used in v-plugins directive
   */
  plugins: [],

  /** @since 3.11.0 - plugin configs filtered by gid */
  pluginsConfigs: {},

  /** @since 3.11.0 - array of initConfig.plugins names */
  configurationPlugins: [],

  /**
   * Store application current user
   */
  user: null,

  /**
   * Store info of the application map
   */
  map: {
    epsg: '',
    unit: 'metric'
  },

  /**
   * Store info of the elements of GUI of the application
   */
  gui: {

    app: {
      /**
       * true = application is disabled and unclickable (waiting)
       */
      disabled: false
    },

    sidebar: {
      /**
       * true = sidebar is disabled (not responsive)
       */
      disabled: false,
      /**
       * @since v3.11.0
       * true open, false hide - icons only
       */
      open    : true,
    },

    layout: {
      /**
       * store the current layout owner ("app" = default)
       */
      __current: 'app',

      /**
       * Store application layout info (rightpanel)
       */
      app:       {}

    }

  },

  /**
   * Sore vendor keys need it by application third part script
   */
  keys: {
    vendorkeys: {
      google: undefined,
      bing:   undefined
    }
  },

  /**
   * Store tokens, used by server, for example, to filter features
   */
  tokens: {
    filtertoken: undefined
  },

  /**
   * @since 3.10.0
   */
  querybuilder: {
    cache:    {},
    searches: JSON.parse(window.localStorage.getItem('QUERYBUILDERSEARCHES') || "{}"),
  },

  /**
   * @since 3.11.0
   */
  navbaritems: [],

  /**
   * @since 3.11.0
   */
  sidebar: {
    title: '',
    components:   [],
    /** DOM element where insert the component/panel  */
    parent:     null,
    /** barstack state. It stores the panel array */
    contentsdata: [], // Array<{ content, options }>
    /** @since 3.11.3 - whether to enable close button  */
    btn_close: true,
    /** @since 3.11.3 - custom tooltip for close button */
    tooltip_close: 'close',
  },

  contentsdata: [],

  /**
   * @since 3.11.0
   */
  viewport: {
    // used to store if content vertical or horizontal is  changed by resised
    resized: {
      start: false,
      'h':   false,
      'v':   false
    },
    // splitting orientation (h = horizontal, v = vertical)
    split: 'h',
    //map
    map: {
      sizes: {
        width:  0,
        height: 0
      },
    },
    //content
    content: {
      loading:  false,
      disabled: false,
      sizes: {
        width:  0,
        height: 0
      },
      // store the resize vertical or horizontal
      resize: {
        'h': { perc: 0 },
        'v': { perc: 0 }
      },
      showgoback:   true,
      stack:        [], // array elements of stack contents
      closable:     true, // (x) is closable
      backonclose:  false, // back on prevoius content
      contentsdata: [], // content data array
    },
    usermessage: {
      id:          null, // unique identify
      show:        false,
      title:       null,
      message:     null,
      position:    null,
      type:        null,
      draggable:   null,
      cloasable:   null,
      autoclose:   null,
      textMessage: false,
      hooks: {
        header: null,
        body:   null,
        footer: null
      }
    },
    // content of viewport (map and content)
    components: {
      map:     null,
      content: null
    },
  },

  sizes: {
    sidebar: {
      width:0
    }
  },

  /** @since 3.11.0 */
  project: new G3WObject,

  /** @since 3.11.0 */
  catalog: {},

  /** @since 3.11.0 */
  highlightlayers: false,

});

export default STATE;